export default __webpack_public_path__ + "static/media/libero.6d2ebb28.png";